export default __webpack_public_path__ + "existing-staff-white-icon.svg";